import { AnalyticsEndpoint } from "./AnalyticsEndpoint";
import { Part } from "./Part";
import { PlayerControls } from "./PlayerControls";
import { ScenarioElement } from "./ScenarioElement";
import { Skin } from "./Skin";
import { PartDebugInfo } from "./DebugPartInfo";

export class FullPlayerConfiguration {
  constructor(
    public code: string,
    public scenarioElements: ScenarioElement[],
    public analyticsEndpoints: AnalyticsEndpoint[],
    public aspectRatio: number,
    public parts: Part[],
    public partsDebugInfo: PartDebugInfo[],
    public videoDate: number,
    public playerControls: PlayerControls,
    public status: "READY" | "PREPARING" | "DELETED",
    public playerServerUrl: string,
    public ctaStorageUrl: string,
    public videoJSUrl: string,
    public lottieUrl: string,
    public adminMode: boolean,
    public autoplay: boolean,
    public mutedStart: boolean,
    public subtitlesActiveOnStart: boolean,
    public personalizationJSON?: any,
    public campaign?: string,
    public skin?: Skin,
    public groupId?: number,
    public scenarioMusicUrl?: string,
  ) {
    this.createDefaultLogoUrl();
    // @ts-ignore
    window.CONFIG = this;
  }

  get hasScenarioElementWithVideo(): boolean {
    return this.scenarioElements.reduce((acc, scEl) => acc || !!scEl.video, false);
  }

  get hasScenarioElementWithAnimation(): boolean {
    return this.scenarioElements.reduce((acc, scEl) => acc || (!!scEl.animations && scEl.animations.length > 0), false);
  }

  findScenarioElement(id: string) {
    return this.scenarioElements.find((el) => el.id === id);
  }

  getInitialScenarioElement(): ScenarioElement {
    return this.scenarioElements.find((el) => el.initial);
  }

  private createDefaultLogoUrl() {
    const { logo, logoVisiblePermanently } = this.playerControls;

    // Empty logo parameter means that we are showing a Vintom Logo which should have a clickable url
    if (!logo && logoVisiblePermanently) {
      this.playerControls.logoUrl = `https://www.vintom.com/?utm_source=vintom-player&utm_medium=player&utm_campaign=${this.campaign}`;
    }
  }
}
